<!-- 

	Changelog
		2020-09-02	init

-->

<template>
	<div class="MhFormTests" :class="elmClasses">
		
		<strong style="font-size: 2.5em; padding: 0.5em 0; display: block;">MhForm Examples</strong><hr />
		
		<div>
			<strong>Events</strong><hr />
			@change : Returns the native event<br />
			@input  : Returns the changed value. Returns array for BaseSelect with multiple="true"<br />
			<hr />
			<strong>Todo</strong><hr />
			<mark>• Add and finish BaseButton</mark><br />
			<mark>• Add id prop</mark><br />
			<mark>• Add focused styles</mark><br />
			<mark>• Add Examples to Vue-Files</mark><br />
			<mark>• Add css vars syntax for BaseSelect</mark><br />
			
			<mark>• BaseTextarea: Add required prop</mark><br />
			<mark>• BaseTextarea: Add disabled prop</mark><br />
			
			<mark>• BaseSelect: Add required prop</mark><br />
			<mark>• BaseSelect: Add disabled prop</mark><br />
			<mark>• BaseSelect multiple: add shift select</mark><br />
			
			<mark>• BaseRadio: Add required prop, geht das überhaupt?</mark><br />
			<mark>• BaseRadio: Add disabled prop</mark><br />
			
			<mark>• BaseButton: Add disabled prop</mark><br />
			<mark>• BaseButton: Add loading prop</mark><br />
			
			<mark>• Add Form with Submit-Button to test required prop</mark><br />
			<hr />
			<label><input type="checkbox" v-model="debug" /> Debug Mode</label>
			<hr />
			<br /><br /><br />
		</div>
		
		<!-- BaseFileInput -->
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseFileInput</strong><br />
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseFileInput1.code"></textarea>
				</div>
				<div class="">
					<BaseFileInput
						:label="'Choose files ...'"
						:accept="'.csv'"
						:multiple="true"
					></BaseFileInput>
				</div>
			</div>
		</div>
		
		<!-- BaseButton -->
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseButton</strong>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseButton1.code"></textarea>
				</div>
				<div class="">
					<BaseButton
						:label="'Senden'"
						@click.native="BaseButton1_click"
					></BaseButton>					
				</div>
			</div>
		</div>
		
		<!-- BaseDate -->
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseDate without value <mark>in safari not working yet!</mark></strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseDate1.code"></textarea>
					<pre name="BaseDate1.model">{{BaseDate1.model}}</pre>
				</div>
				<div class="">
					<BaseDate
						v-model="BaseDate1.model"						
						:debug="debug"
						@input="BaseDate1_input"
						@change="BaseDate1_change"
					></BaseDate>
					<input type="date" @input="trashInput" />
					<input type="date" @input="trashInput" value="0002-10-20" />
					<br /><br />
				</div>
			</div>
		</div>
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseDate with initial value</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseDate2.code"></textarea>
					<pre name="BaseDate2.model">{{BaseDate2.model}}</pre>
				</div>
				<div class="">
					<BaseDate
						v-model="BaseDate2.model"						
						:debug="debug"
						@input="BaseDate2_input"
						@change="BaseDate2_change"
					></BaseDate>
					<br /><br />
				</div>
			</div>
		</div>
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseDate with formated initial value</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseDate3.code"></textarea>
					<pre name="BaseDate3.model">{{BaseDate3.model}}</pre>
				</div>
				<div class="">
					<BaseDate
						v-model="BaseDate3.model"						
						:format="'dd.mm.yyyy'"						
						:debug="debug"
						@input="BaseDate3_input"
						@change="BaseDate3_change"
					></BaseDate>
					<br /><br />
					<button @click="BaseDate3.model = '31.02.2020'">Change model to invalid 31.02.2020</button> &emsp;
					<button @click="BaseDate3.model = '01.05.2020'">Change model to valid 01.05.2020</button> &emsp;
					<button @click="BaseDate3.model = ''">Change model to empty</button> &emsp;
				</div>
			</div>
		</div>
		
		<!-- BaseCheckbox -->
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseCheckbox with checked- and unchecked-value</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseCheckbox1.code"></textarea>
					<pre name="BaseCheckbox1.model">{{BaseCheckbox1.model}}</pre>
				</div>
				<div class="">
					<BaseCheckbox
						v-model="BaseCheckbox1.model"
						:checked-value="'accepted'"
						:unchecked-value="'not_accepted'"
						:debug="debug"
						@input="BaseCheckbox1_input"
						@change="BaseCheckbox1_change"
					></BaseCheckbox>
					<br /><br />
					<button @click="BaseCheckbox1.model = 'accepted'">Change model to 'accepted'</button> &emsp;
					<button @click="BaseCheckbox1.model = 'trash'">Change model to 'trash'</button>
				</div>
			</div>
		</div>
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseCheckbox with boolean model, required</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseCheckbox2.code"></textarea>
					<pre name="BaseCheckbox2.model">{{BaseCheckbox2.model}}</pre>
				</div>
				<div class="">
					<BaseCheckbox
						v-model="BaseCheckbox2.model"
						:debug="debug"
						:required="true"
						@input="BaseCheckbox2_input"
						@change="BaseCheckbox2_change"
					></BaseCheckbox>
					<br /><br />
					<button @click="BaseCheckbox2.model = true">Change model to true</button> &emsp;
					<button @click="BaseCheckbox2.model = false">Change model to false</button>
				</div>
			</div>
		</div>
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseCheckbox with boolean model and label</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseCheckbox3.code"></textarea>
					<pre name="BaseCheckbox3.model">{{BaseCheckbox3.model}}</pre>
				</div>
				<div class="">
					<BaseCheckbox
						v-model="BaseCheckbox3.model"
						:label="'amazing label'"
						:debug="debug"
						@input="BaseCheckbox2_input"
						@change="BaseCheckbox2_change"
					></BaseCheckbox>
					<br /><br />
					<button @click="BaseCheckbox3.model = true">Change model to true</button> &emsp;
					<button @click="BaseCheckbox3.model = false">Change model to false</button>
				</div>
			</div>
		</div>
		
		<!-- BaseRadio -->
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseRadio with initial value</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseRadio1.code"></textarea>
					<pre name="BaseRadio1.model">{{BaseRadio1.model}}</pre>
				</div>
				<div class="">
					<BaseRadio
						v-model="BaseRadio1.model"
						:checked-value="'mario'"
						:name="'lieblingsbruder'"
						:debug="debug"
						@input="BaseRadio1_input"
						@change="BaseRadio1_change"
					></BaseRadio>
					<br />
					<BaseRadio
						v-model="BaseRadio1.model"
						:checked-value="'heiko'"
						:name="'lieblingsbruder'"
						:debug="debug"
						@input="BaseRadio1_input"
						@change="BaseRadio1_change"
					></BaseRadio>
					<br /><br />
					<button @click="BaseRadio1.model = 'mario'">Change model to 'mario'</button> &emsp;
					<button @click="BaseRadio1.model = 'heiko'">Change model to 'heiko'</button>
				</div>
			</div>
		</div>
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseRadio with empty initial value and labels</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseRadio2.code"></textarea>
					<pre name="BaseRadio2.model">{{BaseRadio2.model}}</pre>
				</div>
				<div class="">
					<BaseRadio
						v-model="BaseRadio2.model"
						:checked-value="'jimi'"
						:label="'jimi'"
						:name="'musiker'"
						:debug="debug"
						@input="BaseRadio2_input"
						@change="BaseRadio2_change"
					></BaseRadio>
					<br />
					<BaseRadio
						v-model="BaseRadio2.model"
						:checked-value="'bob'"
						:label="'bob'"
						:name="'musiker'"
						:debug="debug"
						@input="BaseRadio2_input"
						@change="BaseRadio2_change"
					></BaseRadio>
					<br /><br />
					<button @click="BaseRadio2.model = 'jimi'">Change model to 'jimi'</button> &emsp;
					<button @click="BaseRadio2.model = 'bob'">Change model to 'bob'</button> &emsp;
					<button @click="BaseRadio2.model = ''">Change model to ''</button>
				</div>
			</div>
		</div>
		
		<!-- BaseTextarea -->
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseTextarea without inital value and with placeholder</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseTextarea1.code"></textarea>
					<pre name="BaseTextarea1.model">{{BaseTextarea1.model}}</pre>
				</div>
				<div class="">
					<BaseTextarea
						v-model="BaseTextarea1.model"
						:placeholder="'Type something ...'"
						:debug="debug"
						@input="BaseTextarea1_input"
						@change="BaseTextarea1_change"
					></BaseTextarea>
					<br />
					<button @click="BaseTextarea1.model = 'ABC'">Change model to 'ABC'</button> &emsp;
					<button @click="BaseTextarea1.model = ''">Change model to ''</button> &emsp;
				</div>
			</div>
		</div>
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseTextarea with value</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseTextarea2.code"></textarea>
					<pre name="BaseTextarea2.model">{{BaseTextarea2.model}}</pre>
				</div>
				<div class="">
					<BaseTextarea
						v-model="BaseTextarea2.model"
						:debug="debug"
						@input="BaseTextarea2_input"
						@change="BaseTextarea2_change"
					></BaseTextarea>
					<br />
					<button @click="BaseTextarea2.model = 'ABC'">Change model to 'ABC'</button> &emsp;
					<button @click="BaseTextarea2.model = ''">Change model to ''</button> &emsp;
				</div>
			</div>
		</div>
		
		<!-- BaseText -->
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseText without inital value and with placeholder</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseText1.code"></textarea>
					<pre name="BaseText1.model">{{BaseText1.model}}</pre>
				</div>
				<div class="">
					<BaseText
						v-model="BaseText1.model"
						:placeholder="'Type something ...'"
						:debug="debug"
						@input="BaseText1_input"
						@change="BaseText1_change"
					></BaseText>
					<br />
					<button @click="BaseText1.model = 'ABC'">Change model to 'ABC'</button> &emsp;
					<button @click="BaseText1.model = ''">Change model to ''</button> &emsp;
				</div>
			</div>
		</div>
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseText with inital value, required</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseText2.code"></textarea>
					<pre name="BaseText2.model">{{BaseText2.model}}</pre>
				</div>
				<div class="">
					<BaseText
						v-model="BaseText2.model"
						:required="true"
						:debug="debug"
						@input="BaseText2_input"
						@change="BaseText2_change"
					></BaseText>
					<br />
					<button @click="BaseText2.model = 'ABC'">Change model to 'ABC'</button> &emsp;
					<button @click="BaseText2.model = ''">Change model to ''</button> &emsp;
				</div>
			</div>
		</div>
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseText with disabled value</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseText3.code"></textarea>
					<pre name="BaseText3.model">{{BaseText3.model}}</pre>
				</div>
				<div class="">
					<BaseText
						v-model="BaseText3.model"
						:disabled="true"
						:debug="debug"
						@input="BaseText3_input"
						@change="BaseText3_change"
					></BaseText>
					<br />
					<button @click="BaseText3.model = 'ABC'">Change model to 'ABC'</button> &emsp;
					<button @click="BaseText3.model = ''">Change model to ''</button> &emsp;
				</div>
			</div>
		</div>
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseText with clear button</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseText4.code"></textarea>
					<pre name="BaseText4.model">{{BaseText4.model}}</pre>
				</div>
				<div class="">
					<BaseText
						v-model="BaseText4.model"
						:hasClearButton="true"
						:debug="debug"
						@input="BaseText4_input"
						@change="BaseText4_change"
					></BaseText>
					<br />
					<button @click="BaseText4.model = 'ABC'">Change model to 'ABC'</button> &emsp;
					<button @click="BaseText4.model = ''">Change model to ''</button> &emsp;
				</div>
			</div>
		</div>
		
		<!-- BaseSelect -->
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseSelect without inital value and with label</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseSelect1.code"></textarea>
					<pre name="BaseSelect1.model">{{BaseSelect1.model}}</pre>
				</div>
				<div class="">
					<BaseSelect 
						v-model="BaseSelect1.model"
						:label="'Choose ...'"
						:options="[
							'Mario',
							'Heiko',
							'Silvio'
						]"
						:debug="debug"
						@input="BaseSelect1_input"
						@change="BaseSelect1_change"
					></BaseSelect>
					<br />
					<button @click="BaseSelect1.model = 'Silvio'">Change model to 'Silvio'</button> &emsp;
					<button @click="BaseSelect1.model = ''">Change model to ''</button> &emsp;
				</div>
			</div>
		</div>		
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseSelect with inital value</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseSelect2.code"></textarea>
					<pre name="BaseSelect.model">{{BaseSelect2.model}}</pre>
				</div>
				<div class="">
					<BaseSelect 
						v-model="BaseSelect2.model"
						:label="'Choose ...'"
						:options="[
							'Mario',
							'Heiko',
							'Silvio'
						]"
						:debug="debug"
						@input="BaseSelect2_input"
						@change="BaseSelect2_change"
					></BaseSelect>
					<br />
					<button @click="BaseSelect2.model = 'Silvio'">Change model to 'Silvio'</button> &emsp;
					<button @click="BaseSelect2.model = ''">Change model to ''</button> &emsp;
				</div>
			</div>
		</div>
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseSelect multiple with two inital values</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseSelect3.code"></textarea>
					<pre name="BaseSelect3.model">{{BaseSelect3.model}}</pre>
				</div>
				<div class="">
					<BaseSelect 
						v-model="BaseSelect3.model"
						:label="'Choose ...'"
						:multiple="true"
						:options="[
							'Mario',
							'Heiko',
							'Silvio'
						]"
						:debug="debug"
						@input="BaseSelect3_input"
						@change="BaseSelect3_change"
					></BaseSelect>
					<br />
					<button @click="BaseSelect3.model = ['Silvio']">Change model to ['Silvio']</button> &emsp;
					<button @click="BaseSelect3.model = []">Change model to []</button> &emsp;
				</div>
			</div>
		</div>
		<div class="MhFormTests__example">
			<div class="MhFormTests__exampleHeader">
				<strong>BaseSelect multiple with one valid and one invalid value</strong><br/>
			</div>
			<div class="MhFormTests__exampleBody">
				<div class="">
					<textarea class="MhFormTests__exampleCode" v-model="BaseSelect4.code"></textarea>
					<pre name="BaseSelect4.model">{{BaseSelect4.model}}</pre>
				</div>
				<div class="">
					<BaseSelect 
						v-model="BaseSelect4.model"
						:label="'Choose ...'"
						:multiple="true"
						:options="BaseSelect4.options"
						:debug="debug"
						@input="BaseSelect4_input"
						@change="BaseSelect4_change"
					></BaseSelect>
					<br />
					<button @click="BaseSelect4.model = ['Silvio']">Change model to ['Silvio']</button> &emsp;
					<button @click="BaseSelect4.model = ['Heiko', 'Invalid']">Change model to ['Heiko', 'Invalid']</button> &emsp;
					<button @click="BaseSelect4.model = []">Change model to []</button> &emsp;
					<button @click="BaseSelect4.options = ['Apfel', 'Birne', 'Tomate', 'Philipp']">Change options to ['Apfel', 'Birne', 'Tomate', 'Philipp']</button> &emsp;
				</div>
			</div>
		</div>
	
	</div>
</template>

<script>
	// @ is an alias to /src
	//import { EventBus } from '@/event-bus.js'
	import BaseSelect from './BaseSelect.vue'
	import BaseText from './BaseText.vue'
	import BaseTextarea from './BaseTextarea.vue'
	import BaseCheckbox from './BaseCheckbox.vue'
	import BaseRadio from './BaseRadio.vue'
	import BaseDate from './BaseDate.vue'
	import BaseButton from './BaseButton.vue'
	import BaseFileInput from './BaseFileInput.vue'

	export default {
		name: 'MhFormTests',
		components: {
			BaseSelect,
			BaseText,
			BaseTextarea,
			BaseCheckbox,
			BaseRadio,
			BaseDate,
			BaseButton,
			BaseFileInput,
		},
		mixins: [],
		props: {},
		data() {
			return {
				debug : true,
												
				BaseFileInput1 : {
					code : [
						`<BaseFileInput`,
						`	:label="'Choose files ...'"`,
						`	:multiple="true"`,
						`	:accept="'.csv'"`,
						`></BaseFileInput>`,
					].join('\n'),
				},
												
				BaseButton1 : {
					code : [
						`<BaseButton`,
						`	:label="'Senden'"`,
						`	@click.native="BaseButton1_click"`,
						`></BaseButton>`,
					].join('\n'),
				},
												
				BaseDate1 : {
					code : [
						`<BaseDate`,
						`	v-model="BaseDate1.model"`,
						`	@input="BaseDate1_input"`,
						`	@change="BaseDate1_change"`,
						`></BaseDate>`,
					].join('\n'),
					model : '',
				},
				BaseDate2 : {
					code : [
						`<BaseDate`,
						`	v-model="BaseDate2.model"`,
						`	@input="BaseDate2_input"`,
						`	@change="BaseDate2_change"`,
						`></BaseDate>`,
					].join('\n'),
					model : '1978-10-20',
				},
				BaseDate3 : {
					code : [
						`<BaseDate`,
						`	v-model="BaseDate3.model"`,
						`	:format="'dd.mm.yyyy'"`,
						`	@input="BaseDate3_input"`,
						`	@change="BaseDate3_change"`,
						`></BaseDate>`,
					].join('\n'),
					model : '20.10.1978',
				},
				
				BaseCheckbox1 : {
					code : [
						`<BaseCheckbox`,
						`	v-model="BaseCheckbox1.model"`,
						`	:checked-value="'accepted'"`,
						`	:unchecked-value="'not_accepted'"`,
						`	@input="BaseCheckbox1_input"`,
						`	@change="BaseCheckbox1_change"`,
						`></BaseCheckbox>`,
					].join('\n'),
					model : 'not_accepted',
				},
				BaseCheckbox2 : {
					code : [
						`<BaseCheckbox`,
						`	v-model="BaseCheckbox2.model"`,
						`	:required="true"`,
						`	@input="BaseCheckbox2_input"`,
						`	@change="BaseCheckbox2_change"`,						
						`></BaseCheckbox>`,
					].join('\n'),
					model : true,
				},
				BaseCheckbox3 : {
					code : [
						`<BaseCheckbox`,
						`	v-model="BaseCheckbox3.model"`,
						`	:label="'amazing label'"`,
						`	@input="BaseCheckbox3_input"`,
						`	@change="BaseCheckbox3_change"`,						
						`></BaseCheckbox>`,
					].join('\n'),
					model : true,
				},
				
				BaseRadio1 : {
					code : [
						`<BaseRadio`,
						`	v-model="BaseRadio1.model"`,
						`	:checked-value="'mario'"`,
						`	:name="'lieblingsbruder'"`,
						`	@input="BaseRadio1_input"`,
						`	@change="BaseRadio1_change"`,						
						`></BaseRadio>`,
						``,
						`<BaseRadio`,
						`	v-model="BaseRadio1.model"`,
						`	:checked-value="'heiko'"`,
						`	:name="'lieblingsbruder'"`,
						`	@input="BaseRadio1_input"`,
						`	@change="BaseRadio1_change"`,						
						`></BaseRadio>`,
					].join('\n'),
					model : 'mario',
				},
				BaseRadio2 : {
					code : [
						`<BaseRadio`,
						`	v-model="BaseRadio2.model"`,
						`	:checked-value="'jimi'"`,
						`	:label="'jimi'"`,
						`	:name="'musiker'"`,
						`	@input="BaseRadio2_input"`,
						`	@change="BaseRadio2_change"`,						
						`></BaseRadio>`,
						``,
						`<BaseRadio`,
						`	v-model="BaseRadio2.model"`,
						`	:checked-value="'bob'"`,
						`	:label="'bob'"`,
						`	:name="'musiker'"`,
						`	@input="BaseRadio2_input"`,
						`	@change="BaseRadio2_change"`,						
						`></BaseRadio>`,
					].join('\n'),
					model : '',
				},
				
				BaseText1 : {
					code : [
						`<BaseText`,
						`	v-model="BaseText1.model"`,
						`	:placeholder="'Type something ...'"`,
						`	@input="BaseText1_input"`,
						`	@change="BaseText1_change"`,						
						`></BaseText>`,
					].join('\n'),
					model : '',
				},
				BaseText2 : {
					code : [
						`<BaseText`,
						`	v-model="BaseText2.model"`,
						`	:required="true"`,
						`	@input="BaseText2_input"`,
						`	@change="BaseText2_change"`,						
						`></BaseText>`,
					].join('\n'),
					model : 'My amazing text!',
				},
				BaseText3 : {
					code : [
						`<BaseText`,
						`	v-model="BaseText3.model"`,
						`	:disabled="true"`,
						`	@input="BaseText3_input"`,
						`	@change="BaseText3_change"`,						
						`></BaseText>`,
					].join('\n'),
					model : 'My disabled value!',
				},
				BaseText4 : {
					code : [
						`<BaseText`,
						`	v-model="BaseText4.model"`,
						`	:hasClearButton="true"`,
						`	@input="BaseText4_input"`,
						`	@change="BaseText4_change"`,						
						`></BaseText>`,
					].join('\n'),
					model : 'My value!',
				},
				
				BaseTextarea1 : {
					code : [
						`<BaseText`,
						`	v-model="BaseTextarea1.model"`,
						`	:placeholder="'Type something ...'"`,
						`	@input="BaseTextarea1_input"`,
						`	@change="BaseTextarea1_change"`,						
						`></BaseText>`,
					].join('\n'),
					model : '',
				},
				BaseTextarea2 : {
					code : [
						`<BaseText`,
						`	v-model="BaseTextarea2.model"`,
						`	@input="BaseTextarea2_input"`,
						`	@change="BaseTextarea2_change"`,						
						`></BaseText>`,
					].join('\n'),
					model : 'Hey Joe :)',
				},
				
				BaseSelect1 : {
					code : [
						`<BaseSelect`,
						`	v-model="BaseSelect1.model"`,
						`	:label="'Choose ...'"`,
						`	:options="[`,
						`		"Mario",`,
						`		"Heiko",`,
						`		"Silvio",`,
						`	]"`,
						`	@input="BaseSelect1_input"`,
						`	@change="BaseSelect1_change"`,						
						`></BaseSelect>`,
					].join('\n'),
					model : '',
				},
				BaseSelect2 : {
					code : [
						`<BaseSelect`,
						`	v-model="BaseSelect2.model"`,
						`	:label="'Choose ...'"`,
						`	:options="[`,
						`		"Mario",`,
						`		"Heiko",`,
						`		"Silvio",`,
						`	]"`,
						`	@input="BaseSelect2_input"`,
						`	@change="BaseSelect2_change"`,						
						`></BaseSelect>`,
					].join('\n'),
					model : 'Heiko',
				},
				BaseSelect3 : {
					code : [
						`<BaseSelect`,
						`	v-model="BaseSelect3.model"`,
						`	:label="'Choose ...'"`,
						`	:options="[`,
						`		"Mario",`,
						`		"Heiko",`,
						`		"Silvio",`,
						`	]"`,
						`	@input="BaseSelect3_input"`,
						`	@change="BaseSelect3_change"`,						
						`></BaseSelect>`,
					].join('\n'),
					model : ['Heiko', 'Silvio'],
				},
				BaseSelect4 : {
					code : [
						`<BaseSelect`,
						`	v-model="BaseSelect4.model"`,
						`	:label="'Choose ...'"`,
						`	:options="[`,
						`		"Mario",`,
						`		"Heiko",`,
						`		"Silvio",`,
						`		"Franzi",`,
						`		"Philipp",`,
						`		"Hanna",`,
						`		"Bärbel",`,
						`		"Andi",`,
						`		"Uli",`,
						`	]"`,
						`	@input="BaseSelect4_input"`,
						`	@change="BaseSelect4_change"`,						
						`></BaseSelect>`,
					].join('\n'),
					options : [
						'Mario', 
						'Heiko', 
						'Silvio',
						'Franzi',
						'Philipp',
						'Hanna',
						'Bärbel',
						'Andi',
						'Uli',
					],
					model : ['Mario', 'Philipp'],
				},
			}
		},
		watch: {},
		computed: {
			elmClasses(){
				const classes = []
				 
				return classes
			},
		},
		methods: {
			trashInput( value ){
				console.log('trashInput:', value)				
			},
			BaseButton1_click( value ){
				console.log('BaseButton1_click:', value)				
			},
			BaseDate1_input( value ){
				//console.log('BaseDate1_input:', value)				
			},
			BaseDate1_change( e ){
				//console.log('BaseDate1_change:', e, e.target.checked)
			},
			BaseDate2_input( value ){
				//console.log('BaseDate2_input:', value)				
			},
			BaseDate2_change( e ){
				//console.log('BaseDate2_change:', e, e.target.checked)
			},
			BaseDate3_input( value ){
				//console.log('BaseDate3_input:', value)				
			},
			BaseDate3_change( e ){
				//console.log('BaseDate3_change:', e, e.target.checked)
			},
			
			BaseCheckbox1_input( value ){
				console.log('BaseCheckbox1_input:', value)				
			},
			BaseCheckbox1_change( e ){
				console.log('BaseCheckbox1_change:', e, e.target.checked)
			},
			BaseCheckbox2_input( value ){
				console.log('BaseCheckbox2_input:', value)				
			},
			BaseCheckbox2_change( e ){
				console.log('BaseCheckbox2_change:', e, e.target.checked)
			},
			BaseCheckbox3_input( value ){
				console.log('BaseCheckbox3_input:', value)				
			},
			BaseCheckbox3_change( e ){
				console.log('BaseCheckbox3_change:', e, e.target.checked)
			},
			
			BaseRadio1_input( value ){
				console.log('BaseRadio1_input:', value)				
			},
			BaseRadio1_change( e ){
				console.log('BaseRadio1_change:', e, e.target.checked)
			},
			BaseRadio2_input( value ){
				console.log('BaseRadio2_input:', value)				
			},
			BaseRadio2_change( e ){
				console.log('BaseRadio2_change:', e, e.target.checked)
			},
			
			BaseText1_input( value ){
				console.log('BaseText1_input:', value)				
			},
			BaseText2_input( value ){
				console.log('BaseText2_input:', value)				
			},
			BaseText3_input( value ){
				console.log('BaseText3_input:', value)				
			},
			BaseText4_input( value ){
				console.log('BaseText4_input:', value)				
			},
			
			BaseText1_change( e ){
				console.log('BaseText1_change:', e, e.target.value)
			},
			BaseText2_change( e ){
				console.log('BaseText2_change:', e, e.target.value)
			},
			BaseText3_change( e ){
				console.log('BaseText3_change:', e, e.target.value)
			},
			BaseText4_change( e ){
				console.log('BaseText4_change:', e, e.target.value)
			},
			
			BaseTextarea1_input( value ){
				console.log('BaseTextarea1_input:', value)				
			},
			BaseTextarea1_change( e ){
				console.log('BaseTextarea1_change:', e, e.target.value)
			},
			BaseTextarea2_input( value ){
				console.log('BaseTextarea2_input:', value)				
			},
			BaseTextarea2_change( e ){
				console.log('BaseTextarea2_change:', e, e.target.value)
			},
			
			BaseSelect1_input( value ){
				console.log('BaseSelect1_input:', value)				
			},
			BaseSelect1_change( e ){
				console.log('BaseSelect1_change:', e, e.target.value)
			},
			BaseSelect2_input( value ){
				console.log('BaseSelect_input:', value)				
			},
			BaseSelect2_change( e ){
				console.log('BaseSelect_change:', e, e.target.value)
			},
			BaseSelect3_input( value ){
				console.log('BaseSelect3_input:', value)				
			},
			BaseSelect3_change( e ){
				console.log('BaseSelect3_change:', e, e.target.value)
			},
			BaseSelect4_input( value ){
				console.log('BaseSelect4_input:', value)				
			},
			BaseSelect4_change( e ){
				console.log('BaseSelect4_change:', e, e.target.value)
			},
		},
		created() {},
		mounted() {},
	}
</script>

<style lang="less">
	.MhFormTests {
		//display: none;
		
		position: fixed;
		top: 0; left: 0; right: 0; bottom: 0;
		padding: 1em;
		z-index: 1;
		background-color: white;
		overflow: auto;
		
		font-size: 14px;
		line-height: 1.2em;
		
		&__example {
			//outline: 1px solid fade( black, 25 );
			//padding: 0 1em 2em 1em;
			padding-bottom: 2em;
		}
		&__exampleHeader {
			font-size: 1.5em;
			padding: 1em 0;
		}
		&__exampleBody {
			//& > * { outline: 1px solid blue; }
			
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-gap: 1em;
		}
		&__exampleCode {
			width: 100%;
			min-height: 15em;
			white-space: pre;
			tab-size: 4;
			font-family: monospace;
			font-size: 13px;
			padding: 0.5em;
			background-color: fade(black, 75);
			color: fade(white, 95);
		}
	}
</style>
